import React from 'react';

import { INITIAL_ANNOUNCEMENT_FORM_STATE } from '../constants';

export const AnnouncementFormContext = React.createContext({
  ...INITIAL_ANNOUNCEMENT_FORM_STATE,
  setValue: () => null,
});
export const AnnouncementFormProvider = AnnouncementFormContext.Provider;
